import { getDataAttr, listen } from "@olmokit/dom";
import { hasGtm } from "@olmokit/core/analytics";

const ATTR = "track-webinar-link";

/**
 * dataLayer che deve scattare quando viene cliccata la card di un webinar o la
 * cta per registrarsi dalla single page.
*
 * @export
*/
export default function trackWebinarLinks() {
  listen("click", `[data-${ATTR}]`, handleClickWebinarLink);
  
  /**
   * This function uses the event callback datalayer variable to handle
   * navigation after the ecommerce data has been sent to Google Analytics.
   *
   * @see https://www.simoahava.com/gtm-tips/use-eventtimeout-eventcallback/
   * @param {Event} event
   * @param {HTMLAnchorElement} $link
   */
  function handleClickWebinarLink(event, $link) {
    if (window["google_tag_manager"]) {
      console.log(window["google_tag_manager"]);
    }
    if (hasGtm()) {
      event.preventDefault();
      const { isRegister, ...data } = getWebinarClickData($link);

      dataLayer.push({
        ...data,
        eventCallback: function () {
          if (isRegister) {
            window.open($link.href, "_blank");
          } else {
            location.href = $link.href;
          }
        },
        eventTimeout: 2000,
      });
    }
  }
}

/**
 * Actually send tracking data
 *
 * @param {HTMLAnchorElement} element
 * @data {{
 *   event: 'webinar click',
 *   webinar: string,
 *   action: 'click card webinar' | 'click CTA Register',
 *   category: string,
 * }} element["dataset"][ATTR]
 */
export function getWebinarClickData(element) {
  let data = getDataAttr(element, ATTR) || {};
  try {
    data = JSON.parse(data);
  } catch (e) {}

  return data;
}
